define('bottomboard',['lib'], function(lib) {
    'use strict';

    return {
    	init: function() {
    		var bottomBoard = lib.$('#e24bottomboard').find('.bottomboard')[0];

            if (bottomBoard) {
                bottomBoard.addEventListener('DOMSubtreeModified', function(e) {
                    // If theres an iframe present in the bottomboard
                    // the ad-loaded class must be added to get the ad header.
                    var adformFrames = lib.$(e.target).find('iframe').length;
                    
                    if (adformFrames > 0) {
                        lib.$(bottomBoard).addClass('ad-loaded');
                    }
                });

                lib.$(bottomBoard).append('<script data-adfscript="//adx.adform.net/adx/?mid=390620"></script>');
                lib.$(bottomBoard).append('<script id="bottomboardAdform" src="//s1.adform.net/banners/scripts/adx.js"></script>');
            }
    	}
    }
});

